import { getApps } from 'firebase/app';

const DEFAULT_APP_NAME = '[DEFAULT]';

export function getActiveSecondaryApp() {
  const apps = getApps();
  const preferredAppName = window.localStorage.getItem('SECONDARY_DATA_NAME');

  if (preferredAppName) {
    const appByName = apps.find((app) => app.name === preferredAppName);
    if (appByName) {
      return appByName;
    }
  }

  try {
    const primaryRaw = window.localStorage.getItem('PRIMARY_DATA');
    if (primaryRaw) {
      const primaryData = JSON.parse(primaryRaw);
      const expectedDatabaseUrl = primaryData?.Firebase?.databaseURL;

      if (expectedDatabaseUrl) {
        const appByDatabase = apps.find(
          (app) => app.name !== DEFAULT_APP_NAME && app.options?.databaseURL === expectedDatabaseUrl
        );
        if (appByDatabase) {
          return appByDatabase;
        }
      }
    }
  } catch (err) {
    console.warn('No se pudo resolver app secundaria por PRIMARY_DATA', err);
  }

  return apps.find((app) => app.name !== DEFAULT_APP_NAME) || null;
}

export function getNonDefaultApps() {
  return getApps().filter((app) => app.name !== DEFAULT_APP_NAME);
}